import { defineMessages } from 'react-intl';

export default defineMessages({
  closeModal: {
    id: 'FlyoutModal.closeModal',
    description: 'Close modal button aria-label',
    defaultMessage: 'Close modal',
  },
});
